/*
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { auth, db, storage } from '../firebase';
import { collection, getDocs, doc, setDoc } from 'firebase/firestore';
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import styles from './form.module.css';

const Form = () => {
  const [step, setStep] = useState(1);
  const [formData, setFormData] = useState({
    position: '',
    cv: null,
    answers: []
  });
  const [positions, setPositions] = useState([]);
  const [currentQuestion, setCurrentQuestion] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    // Kullanıcı giriş kontrolü
    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (!user) {
        alert('Başvuru yapmak için önce giriş yapmalısınız.');
        navigate('/giris');
      }
    });

    // Pozisyonları çekme
    const fetchPositions = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, 'positions'));
        const fetchedPositions = [];
        querySnapshot.forEach((doc) => {
          fetchedPositions.push({ id: doc.id, name: doc.data().name });
        });
        setPositions(fetchedPositions);
      } catch (error) {
        console.error('Error fetching positions: ', error);
      }
    };

    fetchPositions();

    return () => unsubscribe();
  }, [navigate]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleFileChange = (e) => {
    setFormData({ ...formData, cv: e.target.files[0] });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setStep(2); // Sorulara geçiş yap
  };

  const handleAnswer = (answer) => {
    const updatedAnswers = [...formData.answers, { question: questions[currentQuestion], answer }];
    setFormData({ ...formData, answers: updatedAnswers });

    if (currentQuestion < questions.length - 1) {
      setCurrentQuestion(currentQuestion + 1);
    } else {
      // Son soruya gelindiğinde Onayla adımına geçiş yap
      setStep(3);
    }
  };

  const submitFormData = async () => {
    if (auth.currentUser) {
      try {
        const userId = auth.currentUser.uid;
        const cvRef = ref(storage, `cv/${userId}/${formData.cv.name}`);
        await uploadBytes(cvRef, formData.cv);
        const cvUrl = await getDownloadURL(cvRef);
        await setDoc(doc(db, 'applications', userId), {
          userId,
          position: formData.position,
          cvUrl,
          answers: formData.answers,
          timestamp: new Date()
        });
        alert('Başvurunuz başarılı bir şekilde gönderildi!');
        navigate('/hesabim');
      } catch (error) {
        console.error('Error submitting form: ', error);
        alert('Bir hata oluştu. Lütfen tekrar deneyin.');
      }
    } else {
      alert('Lütfen giriş yapın.');
      navigate('/giris');
    }
  };

  const questions = [
    "Şu anda çalışıyor musunuz?",
    "İş tecrübeniz 5 yıldan fazla mı?",
    "İşkolik misiniz?",
    "'Tam bir takım oyuncusuyum.' der misiniz?",
    "Mücadeleyi sever misiniz?",
    "'Okulumda bana inek derlerdi' der misiniz?",
    "Okulda haylaz mı bilinirdiniz?",
    "'Hep bir numara olmayı hedeflerim' der misiniz?",
    "'Ne az ne çok, her şeyin ortası bana yeter' der misiniz?",
    "Sevdiğiniz şeyde fanatik misiniz?",
    "'Bir buluşmaya ilk ben gelirim' der misiniz?",
    "Rahat bir insan mısınız?",
    "Çok pimpirikli misiniz?",
    "Sigara kullanıyor musunuz?",
    "'Reeder'da çalışmaya can atıyorum' der misiniz?",
  ];

  return (
    <main className={styles.main}>
      <section className={styles.section}>
        {step === 1 && (
          <>
            <h1 className={styles.header}>Başvuru Formu</h1>
            <form onSubmit={handleSubmit} className={styles.form}>
              <div className={styles.formGroup}>
                <label className={styles.label}>Pozisyon:</label>
                <select name="position" value={formData.position} onChange={handleChange} required className={styles.input}>
                  <option value="">Pozisyon Seçin</option>
                  {positions.map((position) => (
                    <option key={position.id} value={position.name}>{position.name}</option>
                  ))}
                </select>
              </div>
              <div className={styles.formGroup}>
                <label className={styles.label}>CV:</label>
                <input type="file" name="cv" accept="application/pdf" onChange={handleFileChange} required className={styles.input} />
              </div>
              <button type="submit" className={styles.button}>Devam Et</button>
            </form>
          </>
        )}
        {step === 2 && (
          <div className={styles.questionContainer}>
            <h1 className={styles.header}>Başvuru Formu</h1>
            <p className={styles.question}>{questions[currentQuestion]}</p>
            <button onClick={() => handleAnswer('Evet')} className={styles.answerButton}>Evet</button>
            <button onClick={() => handleAnswer('Hayır')} className={styles.answerButton}>Hayır</button>
          </div>
        )}
        {step === 3 && (
          <div className={styles.confirmationContainer}>
            <h1 className={styles.header}>Başvuru Formu</h1>
            <p className={styles.confirmationText}>Lütfen aşağıdaki bilgileri onaylayın:</p>
            <p><strong>Pozisyon:</strong> {formData.position}</p>
            <p><strong>CV Dosyası:</strong> {formData.cv.name}</p>
            <p><strong>Sorulara Verilen Cevaplar:</strong></p>
            <ul>
              {formData.answers.map((answer, index) => (
                <li key={index}><strong>{answer.question}</strong>: {answer.answer}</li>
              ))}
            </ul>
            <button onClick={submitFormData} className={styles.button}>Onayla</button>
          </div>
        )}
      </section>
    </main>
  );
};

export default Form;
*/

import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { auth, db, storage } from '../firebase';
import { collection, getDocs, doc, setDoc } from 'firebase/firestore';
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import styles from './form.module.css';

const Form = () => {
  const [step, setStep] = useState(1);
  const [formData, setFormData] = useState({
    position: '',
    cv: null,
    answers: []
  });
  const [positions, setPositions] = useState([]);
  const [currentQuestion, setCurrentQuestion] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    // Kullanıcı giriş kontrolü
    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (!user) {
        alert('Başvuru yapmak için önce giriş yapmalısınız.');
        navigate('/giris');
      }
    });

    const fetchPositions = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, 'positions'));
        const fetchedPositions = [];
        querySnapshot.forEach((doc) => {
          fetchedPositions.push({ id: doc.id, name: doc.data().name });
        });
        setPositions(fetchedPositions);
      } catch (error) {
        console.error('Error fetching positions: ', error);
      }
    };

    fetchPositions();

    return () => unsubscribe();
  }, [navigate]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleFileChange = (e) => {
    setFormData({ ...formData, cv: e.target.files[0] });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setStep(2); // Sorulara geçiş yap
  };

  const handleAnswer = (answer) => {
    const updatedAnswers = [...formData.answers, { question: questions[currentQuestion].text, answer }];
    setFormData({ ...formData, answers: updatedAnswers });

    if (currentQuestion < questions.length - 1) {
      setCurrentQuestion(currentQuestion + 1);
    } else {
      setStep(3); // CV yükleme adımına geçiş yap
    }
  };

  const submitFormData = async () => {
    if (auth.currentUser) {
      try {
        const userId = auth.currentUser.uid;
        const cvRef = ref(storage, `cv/${userId}/${formData.cv.name}`);
        await uploadBytes(cvRef, formData.cv);
        const cvUrl = await getDownloadURL(cvRef);

        await setDoc(doc(db, 'jobapplications', userId), {
          userId,
          position: formData.position,
          cvUrl,
          answers: formData.answers,
          timestamp: new Date()
        });

        alert('Başvurunuz başarılı bir şekilde gönderildi!');
        navigate('/hesabim');
      } catch (error) {
        console.error('Error submitting form: ', error);
        alert('Bir hata oluştu. Lütfen tekrar deneyin.');
      }
    } else {
      alert('Lütfen giriş yapın.');
      navigate('/giris');
    }
  };

  const questions = [
    // Evet/Hayır Soruları
    { text: 'Şu anda aktif olarak bir işte çalışıyor musunuz?', type: 'yesno' },
    { text: 'İş deneyiminiz 5 yıldan fazla mı?', type: 'yesno' },
    { text: 'Yüksek düzeyde sorumluluk almak sizin için bir motivasyon kaynağı mıdır?', type: 'yesno' },
    { text: '"Tam bir takım oyuncusuyum" ifadesi sizin için doğru bir ifade mi?', type: 'yesno' },
    { text: 'Zorlu durumlarla karşılaştığınızda mücadele etmeyi tercih eder misiniz?', type: 'yesno' },
    { text: 'Okul yıllarınızda, akademik başarılarınızla tanınıyor muydunuz?', type: 'yesno' },
    { text: 'Kariyer hedeflerinizde "her zaman bir numara olmak" gibi bir hedefiniz var mı?', type: 'yesno' },
    { text: 'Hayatta dengeyi mi yoksa aşırıya gitmeyi mi tercih ediyorsunuz?', type: 'choice', choices: ['Denge', 'Aşırıya gitmek'] },
    { text: 'Sevdiğiniz bir konuda fanatik olma eğiliminde misiniz?', type: 'yesno' },
    { text: 'Buluşmalar ve toplantılar için genellikle erken gelir misiniz?', type: 'yesno' },
    { text: 'İş yerinde düzenli ve disiplinli çalışmayı tercih eder misiniz?', type: 'yesno' },
    { text: 'İşyerinde değişime kolay adapte olabilir misiniz?', type: 'yesno' },
    { text: 'Sigara kullanıyor musunuz?', type: 'yesno' },
    { text: 'Yeni sorumluluklar almak sizi heyecanlandırır mı?', type: 'yesno' },

    // Şıklı Sorular
    { text: 'Beklenmedik bir kriz durumunda stresli hissettiğinizde nasıl tepki verirsiniz?', type: 'choice', choices: [
        'Sakin kalır, çözüm için hızlıca plan yapar ve aksiyon alırım.',
        'Öncelikle stresimi yönetmeye çalışırım, ancak çözüm bulmada zorlanırım.',
        'Stres seviyem yüksek olursa, karar vermekte zorlanırım, bir süre duraksayabilirim.',
        'Stresli hissettiğimde paniğe kapılırım, çevremdeki kişilerin desteğine ihtiyaç duyarım.'
    ]},
    { text: 'Zorlu bir kriz sırasında hangi becerilerinizin daha çok işe yaradığını düşünüyorsunuz?', type: 'choice', choices: [
        'İletişim becerilerim ve problem çözme yeteneğim.',
        'Çabuk karar verme yeteneğim ve liderlik becerilerim.',
        'Sakin kalma yeteneğim ve olayları soğukkanlılıkla değerlendirme becerim.',
        'Takım çalışması ve işbirliği yapma becerim.'
    ]},
    { text: 'Aşağıdaki özelliklerden hangileri sizi en iyi tanımlar?', type: 'choice', choices: [
        'Sevgi, saygı, empati, dinleme',
        'Kararlılık, liderlik, yönetim, strateji',
        'Yaratıcılık, yenilikçilik, esneklik, risk alma',
        'Disiplin, planlama, zaman yönetimi, sorumluluk'
    ]},

    // Klasik Sorular
    { text: '2+2x5-1 işleminin sonucunu hesaplayınız.', type: 'text' },
    { text: 'Hayranlık duyduğunuz bir bilim insanı var mı? Adını paylaşabilir misiniz?', type: 'text' }
  ];

  return (
    <main className={styles.main}>
      <section className={styles.section}>
        {step === 1 && (
          <>
            <h1 className={styles.header}>Başvuru Formu</h1>
            <form onSubmit={handleSubmit} className={styles.form}>
              <div className={styles.formGroup}>
                <label className={styles.label}>Pozisyon:</label>
                <select name="position" value={formData.position} onChange={handleChange} required className={styles.input}>
                  <option value="">Pozisyon Seçin</option>
                  {positions.map((position) => (
                    <option key={position.id} value={position.name}>{position.name}</option>
                  ))}
                </select>
              </div>
              <button type="submit" className={styles.button}>Devam Et</button>
            </form>
          </>
        )}
        {step === 2 && (
          <div className={styles.questionContainer}>
            <h1 className={styles.header}>Başvuru Formu</h1>
            <p className={styles.question}>{questions[currentQuestion].text}</p>
            {questions[currentQuestion].type === 'yesno' && (
              <>
                <button onClick={() => handleAnswer('Evet')} className={styles.answerButton}>Evet</button>
                <button onClick={() => handleAnswer('Hayır')} className={styles.answerButton}>Hayır</button>
              </>
            )}
            {questions[currentQuestion].type === 'choice' && (
              <>
                {questions[currentQuestion].choices.map((choice, index) => (
                  <button key={index} onClick={() => handleAnswer(choice)} className={styles.answerButton}>{choice}</button>
                ))}
              </>
            )}
            {questions[currentQuestion].type === 'text' && (
              <>
                <input
                  type="text"
                  placeholder="Cevabınızı yazın"
                  onBlur={(e) => handleAnswer(e.target.value)}
                  className={styles.textInput}
                />
              </>
            )}
          </div>
        )}
        {step === 3 && (
          <div className={styles.confirmationContainer}>
            <h1 className={styles.header}>Başvuru Formu</h1>
            <p className={styles.confirmationText}>Lütfen aşağıdaki bilgileri onaylayın:</p>
            <p><strong>Pozisyon:</strong> {formData.position}</p>
            <p><strong>Sorulara Verilen Cevaplar:</strong></p>
            <ul>
              {formData.answers.map((answer, index) => (
                <li key={index}><strong>{answer.question}</strong>: {answer.answer}</li>
              ))}
            </ul>
            <div className={styles.formGroup}>
              <label className={styles.label}>CV:</label>
              <input type="file" name="cv" accept="application/pdf" onChange={handleFileChange} required className={styles.input} />
            </div>
            <button onClick={submitFormData} className={styles.button}>Onayla</button>
          </div>
        )}
      </section>
    </main>
  );
};

export default Form;


